import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'

@Component({
	selector: 'app-textarea-component',
	templateUrl: './textarea.component.html'
})
export class Textarea implements OnChanges {

	@Output() public valueChange = new EventEmitter<{ fieldName: string, text: string }>()

		@Input() public placeHolder: string = ''
	@Input() public maxlength: number = 0
	@Input() public textareaId: string = ''
	@Input() public disabledInput: boolean = false
	@Input() public classTextarea: string = ''
	@Input() public textareaValue: string = ''

	public height: number = 0

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.textareaValue) {
			this.height = this.calcHeight()
		}
	}

		public insert(text: string) {
		const textFormart = this.validateLength(text)

		const textareaHtml = document.getElementById(this.textareaId) as HTMLTextAreaElement

		textareaHtml.value = textFormart

		this.textareaValue = textFormart

		this.inputReturn()
	}

	public validateLength(text: string) {
		const length = text.length

		if (length > this.maxlength) {
			return text.substring(0, this.maxlength)
		}

		return text
	}

	public calcHeight() {
		const valueLength: number = this.textareaValue && this.textareaValue.length

		return Math.ceil(valueLength / 140) * 20
	}

	public inputReturn() {
		this.valueChange.emit({ fieldName: this.textareaId , text: this.textareaValue})
	}
}
